import { render, staticRenderFns } from "./ChangeRequestTableActions.vue?vue&type=template&id=d60d56b6"
import script from "./ChangeRequestTableActions.vue?vue&type=script&lang=ts"
export * from "./ChangeRequestTableActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports